import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TYTCommonModule } from '@tytapp/common';
import { CommonUiModule } from '@tytapp/common-ui';
import { MembershipBenefitsComponent } from './membership-benefits/membership-benefits.component';
import { RedemptionComponent } from './redemption/redemption.component';

export { RedemptionComponent };

@NgModule({
    declarations: [
        RedemptionComponent,
        MembershipBenefitsComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        TYTCommonModule,
        CommonUiModule,
        RouterModule.forChild([
            { path: 'redeem', component: RedemptionComponent },
            { path: 'membership-benefits', component: MembershipBenefitsComponent },
        ])
    ]
})
export class BillingPagesModule {

}